export function isRelayerStep(step) {
    return !!step.typedData && step.typedData.length > 0;
}
export function isGaslessStep(step, chain) {
    return (!!step.typedData?.some((p) => p.primaryType === 'PermitWitnessTransferFrom') ||
        !!(chain && step.typedData?.some((p) => p.message.spender === chain?.permit2)));
}
//# sourceMappingURL=typeguards.js.map